import { styled } from "@mui/material";

export const EmptyText = styled("h3")(() => ({
  fontFamily: "Golos",
  fontSize: "0.8rem",
  lineHeight: "1.375rem",
  fontWeight: 600,
  color: "#747474",
}));
